// Import des images
import galaDesktop from "/assets/images/gala.jpeg";
import iftarDesktop from "/assets/images/iftar-desktop.webp";
import iftarMobile from "/assets/images/iftar.webp";
import radioDesktop from "/assets/images/radio-scolaire-desktop.webp";
import radioMobile from "/assets/images/radio-scolaire.webp";

const events = [
  {
    id: 1,
    title: "Gala caritatif",
    shortDesc:
      "Premier gala caritatif de l’École L’Olivier. Rejoignez-nous pour une soirée spirituelle et conviviale dédiée à l’éducation et à la transmission.",
    longDesc: `
**Et si on se rassemblait ?**  

Pour la première fois, la plus ancienne école musulmane de France organise son Gala caritatif.

Un événement inédit, porteur de sens, pensé pour rassembler celles et ceux qui croient en l’éducation et en la transmission.

Un événement fort, parce que l’union fait la force et que les grandes choses se construisent ensemble.


**Qui sommes-nous ?**  

Fondée il y a plus de 20 ans, l’École L’Olivier œuvre chaque jour pour offrir une éducation complète et exigeante, alliant l’enseignement du Coran, de la langue arabe et les programmes de l’Éducation nationale, dans un cadre structuré, bienveillant et porteur de valeurs.

Hors contrat, elle est entièrement financée par les frais d’inscription et les dons, ce qui rend chaque soutien indispensable.


**Programme de la soirée :**  
- Conférences autour de l’éducation et de la transmission  
- Projection d’un film de présentation de l’école  
- Repas raffiné, propice aux échanges entre acteurs engagés  


⚠️ **PLACES LIMITÉES**  

Nous serions honorés de vous compter parmi nous et prions Allah de placer la baraka dans chaque intention et chaque don.


**Réservez votre place dès maintenant pour une soirée qui compte !**
`,

    date: "14 Février 2026",
    imageDesktop: galaDesktop,
    imageMobile: galaDesktop,
    alt: "Gala evenement caritatif organisé par l'École l'olivier",
    isActive: true,
    isLimited: true,
    isModal: true,
    isLink: true,
    contenuLink : "Réservez votre place",
    link: "https://www.helloasso.com/associations/association-ecole-l-olivier/evenements/gala-de-l-ecole-l-olivier"
  },
  {
    id: 2,
    title: "Iftar de bienfaisance",
    shortDesc:
      "Un repas spécial ramadan. Rejoignez-nous pour un moment convivial et spirituel le vendredi 7 mars à 16h30 à Marseille (3 rue de la Caserne, 13003).",
    longDesc:
      "Au programme :\n📖 Récitations du Noble Coran\n🧠 Quiz interactif\n🗣️ Khutba inspirante sur le mois béni\n🤲 Taraweeh\n\nUne belle occasion de rompre le jeûne ensemble tout en soutenant une noble cause, car tous les bénéfices seront reversés à l'école l'Olivier. 💚\n\n📍 Tarifs :\n👤 Adulte : 20€\n👶 Enfant : 10€",
    date: "15 Mars 2025",
    imageDesktop: iftarDesktop,
    imageMobile: iftarMobile,
    alt: "Iftar de bienfaisance repas spécial ramadan 2025",
  },
  {
    id: 3,
    title: "Radio scolaire",
    shortDesc:
      "Tous les matins sur Instagram, retrouvez nos élèves pour une radio scolaire où ils récitent ensemble de belles invocations",
    date: "20 Juin 2025",
    imageDesktop: radioDesktop,
    imageMobile: radioMobile,
    alt: "Image Radio Scolaire Ramadan",
  },
];

export default events;
